import { IHospitalizedHisInformationItemSelectBehavior } from "../../../../documaker/domain/format/objects";
import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { IHisInformationItemDefaultSelectBehaviorPropertyEditable, instanceOfIHisInformationItemDefaultSelectBehaviorPropertyEditable } from "./IHisInformationItemDefaultSelectBehaviorPropertyEditable";

export interface IHospitalizedHisInformationItemSelectBehaviorPropertyEditable extends IHisInformationItemDefaultSelectBehaviorPropertyEditable {
  hospitalizedHisInformationItemSelectBehavior(): IPropertyEditable<IHospitalizedHisInformationItemSelectBehavior>;
}

export function instanceOfIHospitalizedHisInformationItemSelectBehaviorPropertyEditable(instance: any): instance is IHospitalizedHisInformationItemSelectBehaviorPropertyEditable {
  return instance
      && instance.hospitalizedHisInformationItemSelectBehavior
      && instanceOfIPropertyEditable<IHospitalizedHisInformationItemSelectBehavior>(instance.hospitalizedHisInformationItemSelectBehavior())
      && instanceOfIHisInformationItemDefaultSelectBehaviorPropertyEditable(instance);
}
